import { useMemo } from "react";
import { mapQuestionIndexToPercentage, mapEnumValueToDisplayable } from "../shared/model/GameUtils";

export default function GameDetailStatsComponent({ stats }) {

  const precision = useMemo(() => (stats?.correctAnswers / stats?.answeredQuestions).toPrecision(4) * 100, [stats]);

  const getJokerTextForInt = (val) => {
    if(val <= 0) 
      return "-"
    return mapEnumValueToDisplayable("JOKER").repeat(val)
  }

  return (
    <div className="top-margin vertical-container small gap-1">
      <div className="padding-left horizontal-container">
        <span className="fixed-container">Präzision: {precision}%</span>
        <span className="fixed-container">Endergebnis: {mapQuestionIndexToPercentage(stats?.finalScore)}%</span>
      </div>
      <div className="padding-left horizontal-container">
        <span className="fixed-container">Übrige Joker: {getJokerTextForInt(stats?.leftOverJokers)}</span>
        <span className="fixed-container">Verschwendete Joker: {getJokerTextForInt(stats?.wastedJokers)}</span>
      </div>
    </div>
  );
}
